module.exports = "<p>\r\n  dashboard works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main